export const API_URL = {
    GETWAY_URL: process.env.REACT_APP_GETWAY_API,
    GETWAY_API: process.env.REACT_APP_GETWAY_API + 'insurancebox/',
    GETWAY_DOCS_API: process.env.REACT_APP_GETWAY_API + 'insurancebox-docs/',
};

export const APIV = 1;
export const apikey = `insurancebox-ac1faa7b-9fe9-4483-9525-5cc4ce94c639`;
export const CURRENCY_SYMBOL = '₱';
export const DOC_UPLOAD_VALIDATION = { "minSize": 25000, "maxSize": 5000000 }

export const FIELD_TYPE = {
    TEXT_BOX: 'tb',
    DROP_DOWN: 'dd',
    DROPDOWN_INPUT_FIELD: 'ddtb',
    SEARCHABLE_DROP_DOWN: 'sdd',
    READ_ONLY_TEXT_BOX: 'ro',
    DATE_PICKER: 'date',
    MOBILE_FIELD: 'mobile',
    STICKY_FIELD: "sticky",
    EMAIL: 'email',
    MARKET_MRP: 'market_mrp',
    CITY: 'city',
    STATE: 'state',
    LOCALITY: 'locality',
    RADIO_BOX: 'radio',
    MRP_UPPING: 'mrp_upping',
    CURRENCY: 'currency',
    FUTURE_DATE: 'future_date',
    TELEPHONE: 'telephone',
    CHECK_BOX: 'checkbox',
    SELECT_ADDON: 'select_addon',
    SUM: 'sum',
    TEXT_AREA: 'ta',
    MULTI_DROP_DOWN: 'mdd',
    INFO: 'static_info',
    MMV: 'mmv',
    DATE_TIME: 'date_time',
    TITLE:'title',
    SWITCH:'switch',
    LABEL: 'label',
    MUTLI_RADIO_BOX: 'multiple_radio'
}


export const ADD_ONS_TYPE = {
    BODILY_INJURY: 'bi',
    PROPERTY_DAMAGE: 'pd',
    PERSONAL_ACCIDENT: 'pa',
    RIOTS_STRIKES_CIVIL: 'rsc',
    TOWING_ROWDSIDE: 'tra',
    ACTS_OF_NATURE: 'an'
} 

export const REGEX_DECIMAL_VALIDATION = /^[0-9]*(\.[0-9]{0,2})?$/;

export const REDIRECT_URLS: any = {
	"beta" : "https://stage-sso.carmudi.com.ph/google?redirect=",
	"preprod" : "https://pre-sso.carmudi.com.ph/google?redirect=",
	"prod" : "https://sso.carmudi.com.ph/google?redirect=",
	"local" : "https://stage-sso.carmudi.com.ph/google?redirect="
}
let reactAppEnv: any = process.env.REACT_APP_ENV;
export const AGENT_WEB = 6;

export const REDIRECT_URL: any = REDIRECT_URLS[reactAppEnv]

export const INS_TYPE_COMPREHENSIVE = 1;
export const INS_TYPE_CTPL          = 2;
export const STATUS_TYPE = [{value:"submitted",label:"Submitted",key:"1"},{value:"policy_issued",label:"Issued",key:"2"},{value:"pending_payment",label:"Pending Payment",key:"3"},{value:"pending",label:"Pending Application",key:"4"}]

export const LEAD_LIST_HEADER_COLUMN:any= {"submitted":["Customer Name","Vehicle Details","Plate No" ,"Created On"],"policy_issued":["Customer Name","Vehicle Name","Plate No","Issue Date","Action"],"pending_payment":["Customer Name","Vehicle Name","Plate No","Pending Payment","Due Date","Status"],"pending":["Customer Name","Vehicle Name","Plate No","Created On"],"claim":["Customer Name","Vehicle Details","Policy No","Policy Expiry Date","Claim Status","Action"]}

export const LEAD_LIST_FILTER = {
    taskSummaryFilters: [
      { value: 'all', label: 'Till Today (All)' },
      { value: 'mtd', label: 'MTD' },
      { value: 'cdr', label: 'Custom Date Range' },
    ],
    pendingPaymentFilters: [
      { value: 'nd', label: 'Next 7 Days' },
      { value: 'nm', label: 'Next Month' },
      { value: 'all', label: 'Till Today (All)' },
      { value: 'mdd', label: 'Missed Due Date' },
      { value: 'cdr', label: 'Custom Date Range' },
    ],
    raised_soa : [
      { value: '1', label: 'Yes' },
      { value: '0', label: 'No' }
    ]
};


export const REGEX_DECIMAL_VALIDATION_8 = /^[0-9]*(\.[0-9]{0,8})?$/;


export const WITH_RULE_ENGINE = 1
export const WITHOUT_RULE_ENGINE = 2


export const DOCUMENT_CATEGORY: any = {
    "orcr": 1, "existing_policy": 3, "vehicle_photos": 4,"others":27
}

export const REGEX_EMAIL_VALIDATION = /^[^@]+@[^@]+\.[^@.]{2,5}$/;

export const APP_TYPE_AGENCY = 4;

export const CLAIM_TYPE_CREATED_SOURCE = {claimBox: 1, agentWeb: 2, agentApp: 3}
export const EFFECTIVITY_EXPIRY_INTERVAL = 60;

export const STATUS_CODES = {"success": 200, "failure": 400, 'unauthorized': 401, 'unavailable': 503}

export const SCREEN_SIZE = 768

export const REGEX_NUMBER_WITH_TWO_DECIMAL = /^[0-9]+(\.[0-9]{0,2})?$/;
export const DEFAULT_PAGE_NO = 1;
export const DEFAULT_PAGINATION_COUNT = 10;
export const DEFAULT_INPUTFIELD_LENGTH = 1000;
export const MAX_FILE_UPLOAD = 5;
export const MAX_OTP_TIMER = 59;
export const REGEX_EMAIL = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // eslint-disable-line
export const REGEX_MOBILE = /^[9]\d{9}$/;
export const REGEX_CAMEL_CASE = /(?:^\w|[A-Z]|\b\w)/g;

export const BIKE_INS_VEHICLE_TYPE_ID = 11;
export const COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID = 12;

export const API_VERSION_V2 = 'v2';
export const DOC_COLOR_CODE = {
  OTHER:"#D8EAFF",
  VEHICLE:"#FFF1D6",
  OCR:"#BFF8FC"
}

export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE
export const LEAD_LIST_HEADER_COLUMN_ID:any= {"quotation_shared":["Customer Name","Vehicle Details","Insurer","Insurance ID","shared on","Status","Action"],"submitted":["Customer Name","Vehicle Details","Insurer","Insurance ID","shared on","Status","Action"],"policy_issued":["Customer Name","Vehicle Details","Insurer","Insurance ID","shared on","Action"]}
export const STATUS_TYPE_ID = [{value:"quotation_shared",label:"Quotation Shared",key:"1"},{value:"submitted",label:"Submitted",key:"2"},{value:"policy_issued",label:"Issued",key:"3"}]
export const CURRENCY_CODE = 'en-EU';
export const LOGIN_TYPE = ['agency','sales_user']
export const SUBTRACT_YEAR = { ONE: 1, TWO: 2 , THREE: 3, SIX: 6 }; 
export const ALLOW_MONTH = 6
export const LAST_MONTH = 11
export const CHANGE_PASSWORD_STEP = {
    EMAIL: 1,
    VERIFY_OTP: 2,
    NEW_PASSWORD: 3,
}
export const OTP_INDEXES = [0, 1, 2, 3];
export const MOVE_TO_BASIC_IDS = [8];
export const DISCOUNT_TYPE = {
    DISCOUNT: 1,
    AMOUNT: 2
}

export const PAYMENT_GENERATE_WEB_SOURCE = 2;
export const OCR_EXIST_PARENT_ID = 68;
export const MAX_MOBILE_LENGTH = 12;

export const LEAD_TYPE = {
  AGENT_WEB: 6,
}
export const DOC_IDS = {
  VEHICLE:2,
  EXITING_POLICY:19
}
